import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import kebabCase from 'lodash/kebabCase';
import { FAIcon } from '../fa-icon/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
/**
  This component will display a notication banner at the top of the page between PageWrapper and Header in style dependent on the type prop.
*/

var SystemBanner = function SystemBanner(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      text = _ref.text,
      label = _ref.label,
      icon = _ref.icon,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'generic' : _ref$type;

  var className = _formatClassName(['system-banner', "system-banner-".concat(type)]);

  var dataProps = {};

  if (data.action) {
    dataProps['data-action'] = data.action;
  }

  if (data.objectId) {
    dataProps['data-object-id'] = data.objectId;
  }

  if (data.objectType) {
    dataProps['data-object-type'] = data.objectType;
  }

  if (data.componentType) {
    dataProps['data-component-type'] = data.componentType;
  } else {
    dataProps['data-component-type'] = type ? "".concat(kebabCase(type), "-system-banner") : 'system-banner';
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    className: className
  }, dataProps), icon && /*#__PURE__*/React.createElement(FAIcon, {
    icon: icon
  }), label && /*#__PURE__*/React.createElement("div", {
    className: "system-banner-label"
  }, label), text);
};

SystemBanner.displayName = "SystemBanner";
export { SystemBanner };